import {FilterQueryConfig} from "../../config/filters/filter-query-config.model";
import {FieldToSearch} from "./fields-to-search.model";

export class SearchQuery {

  phrase: string;

  page = 0;

  pageSize = 20;

  sort: string;

  filter: string;

  filterConfigs: FilterQueryConfig[] = [];

  fieldsToSearch: FieldToSearch[] = [];

  facetValue: string;

  facetType: string;

  skipFacets: boolean = false;

  ids: string[] = [];

  materialization: boolean = false;

  constructor(attr: { phrase?: string, page?: number, pageSize?: number, sort?: string, filter?: string, filterConfigs?: FilterQueryConfig[], fieldsToSearch?: FieldToSearch[], ids?: string[], materialization?: boolean, articles?: boolean }) {
    if (attr.phrase) {
      this.phrase = attr.phrase;
    }
    if (attr.page) {
      this.page = attr.page;
    }
    if (attr.pageSize) {
      this.pageSize = attr.pageSize;
    }
    if (attr.sort) {
      this.sort = attr.sort;
    }
    if (attr.filter) {
      this.filter = attr.filter;
    }
    if (attr.filterConfigs) {
      this.filterConfigs = attr.filterConfigs;
    }
    if (attr.fieldsToSearch) {
      this.fieldsToSearch = attr.fieldsToSearch;
    }
    if (attr.ids){
      this.ids = attr.ids;
    }
    if (attr.materialization){
      this.materialization = attr.materialization;
    }
  }
}
